/* eslint-disable */
import React, {useState} from 'react';
import 'contents/assets/scss/page/student.scss';
import Tab from '../../../component/Inc/Tab';
import MonthlyAttendance from '../../../component/student/MonthlyAttendance';

function AttendanceDetail() {
  const [tabIdx, setTabIdx] = useState(0);
  const tab = [
    {title: '과목 별', value: 0},
    {title: '달력', value: 1}
  ];

  return (
    <main className="com_container com_attendance">
      <div className="com_center_wrap">
        <section className="com_tit_wrap">
          <h2 className="com_pg_tit icon menu12_12">
            출석부
            <span className="bar" />
            <span className="point_txt">학생 출석부 (홍학생103ㆍ경기고1ㆍ남)</span>
          </h2>
          <div className="com_btn_wrap">
            <button className="com_btn orange s btn_plus">수시 보고서 작성</button>
            <button className="com_btn orange s btn_plus">첫 수업 보고서 작성</button>
          </div>
        </section>
        <section className="com_pg_container">
          <section className="box full">
            <div className="com_board_list__top">
              <Tab data={tab} tab={tabIdx} setTab={setTabIdx} />
              <span className="com_check_box">
                <input type="checkbox" name="chk" id="chk00" className="com_chk" />
                <label htmlFor="chk00">지난 수업</label>
              </span>
              <div className="group_txt">
                <p className="com_red_txt">* 미 출석체크는 포인트 감점 사유가 됩니다.</p>
                <p className="com_red_txt">* 수시 수업은 ‘보고서’ 등록을 완료해야 출석체크가 인정됩니다.</p>
              </div>
            </div>
            <hr className="com_divider" />
            <div className="com_board_list__top">
              <div className="check">
                <input type="radio" name="rdo_subject" id="rdo_subj_01" className="com_chk circle" />
                <label htmlFor="rdo_subj_01">
                  <strong>수학</strong> <span className="bar" />
                  무럭무럭 수업
                </label>
                <input type="radio" name="rdo_subject" id="rdo_subj_02" className="com_chk circle" />
                <label htmlFor="rdo_subj_02">
                  <strong>과탐</strong> <span className="bar" />
                  튼튼기초
                </label>
                <input type="radio" name="rdo_subject" id="rdo_subj_03" className="com_chk circle" />
                <label htmlFor="rdo_subj_03">
                  <strong>영어</strong> <span className="bar" />
                  기초문법부터
                </label>
              </div>
            </div>
            <table className="com_board_list">
              <colgroup>
                <col width="6%" />
                <col width="10%" />
                <col width="6%" />
                <col width="16%" />
                <col width="6%" />
                <col width="10%" />
                <col width="6%" />
                <col width="10%" />
                <col width="6%" />
                <col />
              </colgroup>
              <tbody>
                <tr>
                  <th>상태</th>
                  <td className="td_point">진행중</td>
                  <th>교사명</th>
                  <td>
                    <div className="com_btn_wrap center">
                      <button className="btn_link">김교사104</button>
                      <button className="btn_link">김교사104</button>
                    </div>
                  </td>
                  <th>전체 수업 수 </th>
                  <td>60</td>
                  <th>진행수업 수</th>
                  <td>
                    10 <span className="bar" />
                    80%
                  </td>
                  <th>출석현황</th>
                  <td>
                    출석5 <span className="bar" />
                    결석2 <span className="bar" /> 조퇴3
                    <span className="bar" />
                    연기3
                  </td>
                </tr>
              </tbody>
            </table>
            {tabIdx === 0 ? (
              <>
                <table className="com_board_list type_attendance">
                  <colgroup>
                    <col />
                    <col />
                  </colgroup>
                  <thead>
                    <tr>
                      <th className="fixed">No</th>
                      {/* 회차수만큼 돌림 */}
                      {[1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20].map((i, idx) => {
                        return <th key={idx}>{idx + 1}회</th>;
                      })}
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td className="fixed">
                        <table className="com_board_list">
                          <tbody>
                            <tr>
                              <th>수업일</th>
                            </tr>
                            <tr>
                              <th>출석부</th>
                            </tr>
                            <tr>
                              <th>출석 체크일</th>
                            </tr>
                            <tr className="type_row_big">
                              <th>메모</th>
                            </tr>
                            <tr>
                              <th>포인트</th>
                            </tr>
                            <tr className="type_row_big">
                              <th>포인트사유</th>
                            </tr>
                            <tr className="type_row_big">
                              <th>수시 보고서</th>
                            </tr>
                          </tbody>
                        </table>
                      </td>
                      <td>
                        <table className="com_board_list">
                          <tbody>
                            <tr>
                              <td className="td_date">2023, 04, 16 18:30</td>
                            </tr>
                            <tr>
                              <td>
                                <button className="com_btn gray xxs">수업연기</button>
                              </td>
                            </tr>
                            <tr>
                              <td className="td_red">2023, 04, 16 18:30</td>
                            </tr>
                            <tr className="type_row_big">
                              <td className="td_date">
                                <div className="memo">죄송합니다. 좀 늦었습니다.죄송합니다. 좀 늦었습니다.죄송합니다. 좀 늦었습니다.죄송합니다. 좀 늦었습니다.</div>
                                <button className="btn_edit" />
                              </td>
                            </tr>
                            <tr>
                              <td className="td_red">-10</td>
                            </tr>
                            <tr className="type_row_big">
                              <td>
                                <div className="memo com_red_txt">
                                  출석 체크
                                  <br />
                                  기간이
                                  <br />
                                  지났습니다.출석 체크
                                  <br />
                                  기간이
                                  <br />
                                  지났습니다.
                                </div>
                              </td>
                            </tr>
                            <tr className="type_row_big">
                              <td>
                                <button className="btn_link blue">
                                  보고서
                                  <br />
                                  보기
                                </button>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </td>
                      <td>
                        <table className="com_board_list">
                          <tbody>
                            <tr>
                              <td className="td_date">2023, 04, 16 18:30</td>
                            </tr>
                            <tr>
                              <td>
                                <button onClick={() => setModalAttendanceCheck(true)} className="com_btn gray xxs">
                                  출석
                                </button>
                              </td>
                            </tr>
                            <tr>
                              <td className="td_date">2023, 04, 16 18:30</td>
                            </tr>
                            <tr className="type_row_big">
                              <td className="td_date">
                                <div className="memo">
                                  학생 사정으로 연기 됐습니다.
                                  <button className="btn_edit" />
                                </div>
                              </td>
                            </tr>
                            <tr>
                              <td className=""></td>
                            </tr>
                            <tr className="type_row_big">
                              <td>
                                <div className="memo com_red_txt">
                                  출석 체크
                                  <br />
                                  기간이
                                  <br />
                                  지났습니다.
                                </div>
                              </td>
                            </tr>
                            <tr className="type_row_big">
                              <td>
                                <button type="button" className="com_btn gray">
                                  보고서
                                  <br />
                                  등록
                                </button>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </td>
                      {[1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18].map((i, idx) => {
                        return (
                          <td key={idx} className="afterday">
                            <table className="com_board_list">
                              <tbody>
                                <tr>
                                  <td className="td_date">2023, 04, 16 18:30</td>
                                </tr>
                                <tr>
                                  <td></td>
                                </tr>
                                <tr>
                                  <td className="td_date"></td>
                                </tr>
                                <tr className="type_row_big">
                                  <td className="td_date">
                                    <div className="memo"></div>
                                  </td>
                                </tr>
                                <tr>
                                  <td className=""></td>
                                </tr>
                                <tr className="type_row_big">
                                  <td>
                                    <div className="memo com_red_txt"></div>
                                  </td>
                                </tr>
                                <tr className="type_row_big">
                                  <td></td>
                                </tr>
                              </tbody>
                            </table>
                          </td>
                        );
                      })}
                    </tr>
                  </tbody>
                </table>
                <div className="com_btn_wrap center">
                  <p className="com_red_txt">* 등록된 보고서는 바로 학생 또는 학부모에게 메일 발송됩니다.</p>
                  <button className="com_btn orange xs">등록</button>
                </div>
              </>
            ) : (
              <>
                <div className="com_calendar_wrap">
                  <div className="year">
                    <button className="btn btn_first"></button>
                    <button className="btn btn_prev"></button>
                    <button className="btn_txt">2023, 03, 31(수)</button>
                    <button className="btn btn_next"></button>
                    <button className="btn btn_last"></button>
                  </div>
                </div>
                <MonthlyAttendance />
              </>
            )}
          </section>
        </section>
      </div>
    </main>
  );
}

export default AttendanceDetail;
